// @flow
import React from 'react';

import { formatDate } from 'Utils/date/dateUtils';
import { Icon } from 'Components/frameworks/icon/Icon';
import { TemplateString } from 'Components/frameworks/template-string/TemplateString';

import { t } from 'Src/i18n';
import { ICONS } from 'Components/utils/icon/icons';
import { COLORS } from 'Components/utils/color/colors';
import { API_DATE_FORMAT } from 'Utils/date/apiDate';
import { getDepartureDate } from 'Components/widgets/alternative-proposals/AlternativeProposalsUtils';

type Props = {|
  arrivalDate: string,
  duration: number,
  resort: $ReadOnly<{
    name: string,
    image?: string,
  }>,
|};

export const AlternativeDateSuggestionHeader = (props: Props) => {
  const { arrivalDate, duration, resort } = props;

  const getFormattedDateTitle = formatDate('DD/MM');
  const departureDate = getDepartureDate({
    date: arrivalDate,
    duration,
    format: API_DATE_FORMAT,
    unit: 'days',
  });

  return (
    <div
      className="bg-white rounded-small md:flex md:justify-center md:w-full"
      data-testid="AlternativeDate"
    >
      <div className="AlternativeProposalsModal-header flex py-4 px-6 md:py-8 md:items-center md:w-full lg:mx-6 lg:px-0">
        <Icon
          className="AternativeProposalsModal-icon flex-shrink self-start"
          color={COLORS.ORANGE}
          name={ICONS.WARNING}
          width="3rem"
          hasRtl
        />
        <div className="AlternativeProposalsModal-title ml-2 rtl:ml-2 rtl:mr-0 md:ml-6 md:rtl:ml-6">
          <div className="text-blue">
            <TemplateString
              template={t('booking.counterProposalPopIn.noAvailabilityOnCriterionLabel')}
              // $FlowFixMe
              values={{ resortName: resort.name }}
            />
          </div>
          <div className="text-orange">
            <TemplateString
              template={t('booking.counterProposalPopIn.notAvailableDates')}
              // $FlowFixMe
              values={{
                arrivalDate: getFormattedDateTitle(arrivalDate, 'YYYYMMDD') || '',
                departureDate: getFormattedDateTitle(departureDate, 'YYYYMMDD') || '',
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
